<template>
    <div class="container">
        <b-modal
            :model-value="showDialogEdit"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            :title="labels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog edit-account-dialog"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ labels.infoTitle }}</div>
                    <div class="password-policy-subtitle">{{ labels.infoText }}</div>
                </div>

                <!-- Campo: Cuenta -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.cuenta }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="Item.cuenta"
                            type="text"
                            class="form-input"
                            disabled
                        />
                    </b-col>
                </b-row>

                <!-- Campo: Nombre -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.name }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="Item.descripcion"
                            type="text"
                            class="form-input"
                            placeholder="Nombre de la cuenta"
                        />
                    </b-col>
                </b-row>

                <!-- Campo: Niif -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.niif }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-select
                            v-model="Item.niif"
                            class="form-input"
                        >
                            <template #first>
                                <b-form-select-option value="" disabled>
                                    -- {{ labels.sel }} --
                                </b-form-select-option>
                            </template>
                            <option 
                                :key="planCons.id" 
                                :value="planCons.niif" 
                                v-for="planCons in listNiif"
                            >
                                {{ planCons?.niif }} - {{ planCons?.nameNiif }}
                            </option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <!-- Campo: ESF -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.esf }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-select
                            v-model="Item.esf"
                            class="form-input"
                        >
                            <b-form-select-option value="">{{ labels.not }}</b-form-select-option>
                            <b-form-select-option value="X">{{ labels.yes }}</b-form-select-option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <!-- Campo: ERI -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.eri }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-select
                            v-model="Item.eri"
                            class="form-input"
                        >
                            <b-form-select-option value="">{{ labels.not }}</b-form-select-option>
                            <b-form-select-option value="X">{{ labels.yes }}</b-form-select-option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <!-- Campo: EFE -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.efe }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-select
                            v-model="Item.efe"
                            class="form-input"
                        >
                            <b-form-select-option value="">{{ labels.not }}</b-form-select-option>
                            <b-form-select-option value="X">{{ labels.yes }}</b-form-select-option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <!-- Campo: ECP -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.ecp }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-select
                            v-model="Item.ecp"
                            class="form-input"
                        >
                            <b-form-select-option value="">{{ labels.not }}</b-form-select-option>
                            <b-form-select-option value="X">{{ labels.yes }}</b-form-select-option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <!-- Campo: Interco -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.interco }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-select
                            v-model="Item.interco"
                            class="form-input"
                        >
                            <template #first>
                                <b-form-select-option value="" disabled>
                                    -- {{ labels.sel }} --
                                </b-form-select-option>
                            </template>
                            <option value="">{{ labels.noGroup }}</option>
                            <option 
                                :key="grupo.interco" 
                                :value="grupo.interco" 
                                v-for="grupo in gruposInterco"
                            >
                                {{ grupo?.descripcion }}
                            </option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <!-- Botones de acción -->
                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="mr-2 reset-btn-secondary" @click="closeDialog">{{ labels.close }}</b-button>
                    <b-button class="reset-btn-primary" @click="confirmSave" :disabled="isSaving">
                        <b-spinner v-if="isSaving" small class="mr-1"></b-spinner>
                        {{ labels.save }}
                    </b-button>
                </div>
            </div>
        </b-modal>

        <!-- Modal Confirmación Eliminar (si se requiere) -->
        <InacticaItem 
            :InactivaItem="showDeleteModal" 
            @confirmDelete="confirmDelete" 
            @cierraModal="closeDeleteModal"
        />
    </div>
</template>

<script>
import PlanCuentas from '../../services/PlanCuentas' 
import GruposIntercos from '../../services/GruposIntercos' 
import InacticaItem from "../utils/InacticaItem.vue"

export default {
    name: "EditarCuenta",
    components: {
        InacticaItem
    },
    props: ['showDialogEdit', 'Item', 'listNiif'],
    data: () => ({
        cuenta: "",
        esf: "",
        eri: "",
        efe: "",
        ecp: "",
        interco: "",
        niif: "",
        gruposInterco: [],
        originalItem: null,
        isSaving: false,
        showDeleteModal: false
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Editar Cuenta",
                    save: "Guardar",
                    close: "Cerrar",
                    cuenta: "Cuenta",
                    name: "Nombre",
                    niif: "NIIF",
                    esf: "ESF",
                    eri: "ERI",
                    efe: "EFE",
                    ecp: "ECP",
                    interco: "Interco",
                    sel: "Seleccione...",
                    yes: "SI",
                    not: "NO",
                    noGroup: "NO",
                    infoTitle: "Datos de la cuenta",
                    infoText: "Actualiza la información de la cuenta y guarda los cambios."
                }
            } else {
                return {
                    title: "Edit Account",
                    save: "Save",
                    close: "Close",
                    cuenta: "Account",
                    name: "Name",
                    niif: "NIIF",
                    esf: "ESF",
                    eri: "ERI",
                    efe: "EFE",
                    ecp: "ECP",
                    interco: "Interco",
                    sel: "Select...",
                    yes: "Yes",
                    not: "No",
                    noGroup: "NO",
                    infoTitle: "Account information",
                    infoText: "Update the account information and save changes."
                }
            }
        },
        hasUnsavedChanges() {
            if (!this.originalItem || this.isSaving) return false
            return JSON.stringify(this.Item) !== JSON.stringify(this.originalItem)
        }
    },
    watch: {
        Item: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.originalItem = { ...newVal }
                }
            }
        },
        showDialogEdit: {
            handler(newVal) {
                if (newVal && this.Item) {
                    this.loadGruposInterco().then(() => {
                        this.originalItem = { ...this.Item }
                        this.isSaving = false
                    })
                }
            },
            immediate: true
        }
    },
    methods: {
        closeDeleteModal() {
            this.showDeleteModal = false
        },
        
        confirmDelete() {
            this.showDeleteModal = false
        },
        
        confirmSave() {
            this.editPlanCuenta()
        },
        
        editPlanCuenta() {
            if (this.Item.descripcion == "") {
                this.$toast.error("Diligenciar el campo Nombre")
                return
            }
            if (this.Item.niif == "") {
                this.$toast.error("Diligenciar el campo Niif")
                return
            }
            
            this.isSaving = true
            
            let form = {
                'nombre': this.Item.descripcion,
                'niif': this.Item.niif,
                'esf': this.Item.esf == "SI" || this.Item.esf == "X" ? "X" : "",
                'eri': this.Item.eri == "SI" || this.Item.eri == "X" ? "X" : "",
                'efe': this.Item.efe == "SI" || this.Item.efe == "X" ? "X" : "",
                'ecp': this.Item.ecp == "SI" || this.Item.ecp == "X" ? "X" : "",
                'interco': this.Item.interco === '' ? null : this.Item.interco,
                'id': this.Item.id,
                'cuenta': this.Item.cuenta,
                'vigencia': this.Item.vigencia,
                'id_compania': this.Item.id_compania,
                'codReporte': this.Item.codReporte,
                'idUser': this.$store.state.userId,
            }
            
            PlanCuentas.planCuentasUpdate(form)
                .then((res) => {
                    this.$toast.success(res.data.message)
                    
                    const niifInfo = this.listNiif.find(niif => niif.niif == form.niif)
                    const nombreNiif = niifInfo ? niifInfo.nameNiif : ''
                    const grupoInterco = this.gruposInterco.find(g => g.interco == form.interco)
                    const intercoDescripcion = grupoInterco ? grupoInterco.descripcion : ''
                    
                    const updatedItem = {
                        ...this.Item,
                        descripcion: form.nombre,
                        niif: form.niif,
                        nombre_niif: nombreNiif,
                        esf: form.esf,
                        eri: form.eri,
                        efe: form.efe,
                        ecp: form.ecp,
                        interco: form.interco,
                        intercoDescripcion: intercoDescripcion
                    }
                    
                    this.originalItem = { ...updatedItem }
                    this.$emit('item-updated', updatedItem)
                    this.$emit('clicked', false)
                    this.isSaving = false
                })
                .catch((err) => {
                    console.log(err)
                    this.$toast.error("Error al actualizar la cuenta")
                    this.isSaving = false
                })
        },
        
        restoreOriginalValues() {
            if (this.originalItem) {
                Object.assign(this.Item, this.originalItem)
            }
        },
        
        getIntercoDisplayValue(intercoValue) {
            if (!intercoValue || intercoValue === '') {
                return this.labels.noGroup
            }
            const grupo = this.gruposInterco.find(g => g?.interco == intercoValue)
            return grupo ? grupo?.descripcion : `Grupo ${intercoValue}`
        },
        
        closeDialog() {
            if (this.hasUnsavedChanges) {
                const message = this.$store.state._language == "es-ES"
                    ? "Tienes cambios sin guardar. ¿Quieres cerrar sin guardar?"
                    : "You have unsaved changes. Do you want to close without saving?"
                if (window.confirm(message)) {
                    this.restoreOriginalValues()
                    this.$emit('clicked', false)
                }
            } else {
                this.$emit('clicked', false)
            }
        },
        
        async loadGruposInterco() {
            try {
                const res = await GruposIntercos.getAllGruposIntercos()
                this.gruposInterco = res.data.gruposIntercos || []
                return this.gruposInterco
            } catch (err) {
                console.error("Error loading grupos interco:", err)
                this.gruposInterco = []
                return []
            }
        }
    }
}
</script>

<style src="../main.css"></style>